import React from 'react';
import DownloadModalButtonWithHandler from './DownloadModalButtonWithHandler';
import { REPORT_FORMAT_TYPES } from '@shared/constants/reportFormatTypes';

const REPORT_OPTIONS = [
  { title: 'PDF', value: REPORT_FORMAT_TYPES.PDF },
  { title: 'CSV', value: REPORT_FORMAT_TYPES.CSV }
];

const DOWNLOAD_TEXT = 'Which format(s) would you like to download?';

/**
 * @typedef {object} PdfCsvDownloadButtonProps
 * @property {string} dataDownloadType
 */

/**
 * @param {PdfCsvDownloadButtonProps} props
 */
const PdfCsvDownloadButton = props => {
  const { dataDownloadType } = props;

  return (
    <DownloadModalButtonWithHandler
      reports={REPORT_OPTIONS}
      dataDownloadType={dataDownloadType}
      reportFormatOptions={[REPORT_FORMAT_TYPES.COMBINED_FORMATS]}
      downloadText={DOWNLOAD_TEXT}
    />
  );
};

export default PdfCsvDownloadButton;
